module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-provide', {
    attrs: {
      "loading": _vm.loadingMatching,
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule,
      "disabledInputList": _vm.isMatch ? _vm.disabledInputList : []
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingConditions || _vm.loadingProductTypes
    }
  }), _vm._v(" "), (_vm.isMatch) ? _c('span', {
    staticClass: "badge u-floatRight status success",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v("Este produto é um match")]) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "required": true,
      "label": _vm.$t('ageGroup.label'),
      "columns": 3,
      "error": _vm.getError('product.ageGroup', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.ageGroup),
      expression: "product.ageGroup"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "ageGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "adult"
    }
  }, [_vm._v(_vm._s(_vm.$t('ageGroup.adult.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kids"
    }
  }, [_vm._v(_vm._s(_vm.$t('ageGroup.kids.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v(_vm._s(_vm.$t('ageGroup.both.label')))])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "required": true,
      "label": _vm.$t('condition.label'),
      "columns": 3,
      "error": _vm.getError('condition', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.condition),
      expression: "product.condition"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "condition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.conditions), function(condition) {
    return _c('option', {
      domProps: {
        "value": condition.value
      }
    }, [_vm._v(_vm._s(condition.label))])
  }), 0)]), _vm._v(" "), (_vm.productTypes.length) ? _c('form-group', {
    attrs: {
      "label": _vm.$t('productTypes.label'),
      "columns": 3,
      "error": _vm.getError('productType', _vm.product.productId),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.productTypes,
      "label": "name",
      "track-by": "value",
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha"
    },
    model: {
      value: (_vm.productType),
      callback: function($$v) {
        _vm.productType = $$v
      },
      expression: "productType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attributes.length) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredAttributes), function(attribute, index) {
    return _c('form-group', {
      key: attribute.id,
      attrs: {
        "label": attribute.name,
        "columns": 3,
        "error": _vm.getError(attribute.name, _vm.product.productId),
        "required": attribute.required
      }
    }, [(attribute.enum && attribute.enum.length) ? [_c('multiselect', {
      attrs: {
        "options": _vm.getMultiselectOptions(attribute),
        "label": "label",
        "track-by": "value",
        "placeholder": attribute.name
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    })] : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "placeholder": attribute.example ? attribute.example : attribute.name
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2659f83c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/amazon/provide/Product.vue
// module id = 2995
// module chunks = 0